// extracted by mini-css-extract-plugin
export var aside = "side-column-module--aside--72436";